<template>
    <div class="animated fadeIn">
        <h3>Flöden</h3>
        <b-card>
            <b-card-body>
                <b-button-toolbar aria-label="Toolbar with button groups and input groups">
                    <b-input-group size="sm">
                        <b-form-input ref="filter" class="text-left" placeholder="Filtrera..."
                            v-model="flt"></b-form-input>
                    </b-input-group>
                    <b-button-group size="sm" class="mr-1">
                        <b-button @click="GetData()" variant="light"
                            size="sm"><b-icon-arrow-repeat /></b-button>&nbsp;<b-button @click="AddNew()"
                            variant="light" size="sm">+</b-button>
                    </b-button-group>

                </b-button-toolbar>

                <b-row>
                    <b-col cols="2">
                        <b-table :fields="fields" :items="GetRoutesFiltered(flt)" :sortable="true" :small="true"
                            selectable select-mode="single" @row-clicked="ShowDetails"></b-table>
                    </b-col>
                    <b-col v-if="work">
                        <b-row>
                            <b-col>
                                <b-button v-if="workReadonly" @click="Change(work, false)">Ändra</b-button>
                                <b-button v-if="!workReadonly" @click="Change(work, true)">Avbryt ändring</b-button>
                            </b-col>
                            <b-col>
                                <b-button v-if="workReadonly" @click="AddNew(work)">
                                    <b-icon-clipboard></b-icon-clipboard> Duplicera
                                </b-button>
                            </b-col>
                            <b-col>
                                <b-button v-if="!workReadonly" @click="Remove(work)" variant="danger">Ta bort flöde
                                </b-button>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col v-if="workAppearance && workAppearance.length > 0">Finns i följande flödeslogik:
                                <!-- <b>{{GetLogicAppearanceSummary(work)}}</b>  -->
                                <b-badge v-for="(s, i) in GetLogicAppearanceSummary(work)" :key="i" variant="primary">
                                    {{ s }}&nbsp;</b-badge>
                            </b-col>
                            <b-col v-if="workAppearance && workAppearance.length == 0">(Ej aktiverad)</b-col>
                        </b-row>
                        <consolidationroutedetails :consolidationroute="work" @changed="GetData()"
                            @cancelled="Change(work,true)" :readonly="workReadonly">
                        </consolidationroutedetails>
                    </b-col>
                </b-row>

            </b-card-body>
        </b-card>
    </div>
</template>
<script>
import consolidationroutedetails from "./../consolidationroute/consolidationroutedetails.vue";

import { Api } from "../../lib/api";
const api = new Api();

export default {
    name: 'consolidationroutelist',
    components: { consolidationroutedetails },
    data() {
        return {
            fields: [
                { key: 'Name', label: 'Namn', sortable: true },
            ],
            routes: [],
            work: null,
            workName: null,
            workReadonly: true,
            workAppearance: null,
            flt: null,
        }
    },
    created() {
        this.GetData();
    },
    methods: {
        GetData() {
            api.get("/api/consolidationroute/GetList").then((res) => {
                //alert("OK");                
                this.work = null;
                this.routes = [];
                res.data.map(x => {
                    this.routes.push({ Name: x })
                });
            });
            setTimeout(() => {
                this.$refs.filter.focus();
            }, 500);
        },
        GetRoutesFiltered(flt) {
            if (!flt)
                return this.routes;
            var s = flt.toLowerCase();
            return this.routes.filter(x => x.Name.toLowerCase().indexOf(s) >= 0);
        },
        ShowDetails(r) {
            this.ShowDetailsByName(r.Name);
        },
        ShowDetailsByName(name) {
            this.work = null;
            this.workName = null;
            this.workReadonly = true;
            this.workAppearance = null;
            api.get("/api/consolidationroute/GetDetails?name=" + name).then((res) => {
                //alert("OK");                
                this.workName = res.data.Name;
                this.work = JSON.parse(res.data.RouteDefinitionJson);
                this.work.name = this.workName;

                console.log(this.work);
            });
            api.get("/api/consolidationroute/GetLogicAppearance?name=" + name).then((res) => {
                this.workAppearance = res.data;
            });
        },
        AddNew(template) {
            var s = prompt('Ange namn');
            if (s) {
                this.workReadonly = false;
                this.workAppearance = null;
                this.workName = s;
                var ws = { steps: [] };
                if (template) {
                    ws = JSON.parse(JSON.stringify(template));
                }
                ws.name = s;
                this.work = ws;
                var p = { Name: this.work.name, RouteDefinitionJson: JSON.stringify(this.work) };
                api.post('/api/consolidationroute/AddOrUpdate', p).then(res => {
                    if (res.data) {
                        alert(res.data);
                        return;
                    }
                    // this.origCopy = JSON.stringify(this.work);
                    // this.$emit('changed', this.work);
                    this.GetData();
                });
            }

        },
        Remove(r) {
            if (this.GetLogicAppearanceSummary().length > 0) {
                alert('Detta flöde är aktivt i logik. Ta bort flödet ur logiken först.');
                return;
            }

            if (confirm(`Ta bort ${r.name}?`)) {
                api.delete("/api/consolidationroute/Remove?name=" + r.name).then((res) => {
                    if (res.data) {
                        alert(res.data);
                        return;
                    }
                    this.GetData();
                });
            }
        },
        Change(r, readonly) {
            if (readonly && !this.workReadonly)
                this.ShowDetailsByName(this.workName);

            this.workReadonly = readonly;
        },
        GetLogicAppearanceSummary() {
            if (this.workAppearance) {
                return this.workAppearance.map(x => {
                    let r = [];
                    if (x.sender)
                        r.push(r.sender);
                    if (x.departureNumber)
                        r.push(x.departureNumber);
                    if (r.length == 0)
                        r.push('(STANDARD)');
                    return r.join('-');
                });
            }
            return [];
        },
    }
}

</script>